import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Input from '../Input/Input';

const SearchInput = ({
  id,
  value,
  label,
  size,
  placeholder,
  onChange,
  disabled,
  onSearch,
  onClear,
  message,
  inputStatus,
}) => {
  const [isSearchButtonDisabled, setSearchButtonDisabled] = useState(true);
  const [showClearButton, setShowClearIcon] = useState(!!value);
  const [inputValue, setInputValue] = useState(value);
  const [valueChanged, setValueChanged] = useState(!!value);

  useEffect(() => {
    setSearchButtonDisabled(disabled);
    setShowClearIcon(!!inputValue);
  }, [inputValue]);

  const proxyOnSearch = () => {
    onSearch && onSearch(inputValue);
  };

  const proxyOnChange = (e) => {
    setInputValue(e.target.value);
    setValueChanged(true);
    onChange && onChange(e);
  };

  const proxyOnClear = () => {
    setInputValue('');
    onClear && onClear();
  };

  const onFocus = () => {
    setSearchButtonDisabled(false);
  };

  const onBlur = () => {
    setSearchButtonDisabled(disabled || !valueChanged);
  };

  const onKeyDown = (e) => {
    e.key === 'Enter' && proxyOnSearch();
  };

  const labelVariants = {
    normal: 'neutral-2',
    error: 'primary-2',
  };

  return (
    <Input
      id={id}
      type='text'
      placeHolder={placeholder}
      onChange={proxyOnChange}
      value={inputValue}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={disabled}
      onKeyDown={onKeyDown}
      searchText={true}
      message={message}
      label={label}
      inputStatus={inputStatus}
      size={size}
      icons={{
        iconLeft: 'search_outline',
        iconRight: showClearButton && {
          name: 'cancel_outline',
          callback: proxyOnClear,
        },
      }}
    />
  );
};

SearchInput.defaultProps = {
  disabled: false,
  value: '',
};

SearchInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  placeHolder: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  onSearch: PropTypes.func,
  onClear: PropTypes.func,
  message: PropTypes.string,
  inputStatus: PropTypes.oneOf(['normal', 'error']),
};

export default SearchInput;
